export default {
  name: 'All accounts',
  subtitle: 'To search for accounts type in some values into filter inputs below',
  fields: {
    number: 'Number',
    type: 'Type',
    glType: 'GL Type',
    regulatoryType: 'Regulatory Type',
    alias: 'Alias',
    name: 'Name',
    branch: 'Branch',
    currency: 'Currency',
    owner: 'Owner',
    profileType: 'Owner Profile Type',
    profileId: 'Owner UUID',
    createdAt: 'Created at',
    status: 'Status',
    withClosed: 'With closed',
    withError: 'With error',
    noResultsFound: 'No results found',
    searchInProgress: 'Search is in progress...',
  },
  profileType: {
    INDIVIDUAL: 'Individual',
    BUSINESS: 'Business',
    PARTNER: 'Partner',
    TENANT: 'Tenant',
  },
  tabs: {
    details: 'Details',
    transactions: 'Transactions',
    events: 'Events',
    balances: 'Balances',
    eventLog: 'Events',
  },
  subheader: 'Id:  %{id}. Created:  %{date}  %{time}',
  show: {
    details: {
      status: 'Status',
      product: 'Product',
      accountNumber: 'Account number',
      type: 'Type',
      glType: 'GL Type',
      branch: 'Branch',
      balancesAndCounters: 'Balances and counters',
      systemInfo: 'System information',
      nameAliasAndDescription: 'Name, Alias and Description',
      aliasAndDescription: 'Alias and description',
      productTemplateName: 'Product template name',
      productTemplateCode: 'Product template code',
      productTemplateCategory: 'Product template category',
      liquidityBucket: 'Liquidity bucket',
      currency: 'Currency',
      currentDay: 'Current day',
      name: 'Name',
      alias: 'Alias',
      description: 'Description',
      owner: 'Owner',
      closedOn: 'Closed on',
      productTemplateFallback:
        'Product template for this account is missing. No current balance/counters/limits information is available. Account can not be used to run transactions.',
    },
    balances: {
      bankingDay: 'End of Banking Day',
      bankingDayFrom: 'Banking day from',
      bankingDayTo: 'Banking day to',
    },
  },
  actions: {
    attention: 'Attention!',
    blockingAlert: 'Please confirm the blocking of the %{accountType} and indicate the reason.',
    unblockingAlert: 'Please confirm the unblocking of the %{accountType} and indicate the reason.',
    closingAlert: 'Please confirm the closing of the %{accountType} and indicate the reason.',
    reason: 'Reason',
    accounts: 'account',
    externalSources: 'external source',
    'tenant/accounts': 'tenant account',
  },
};
